export default __webpack_public_path__ + "static/media/icons8-fish-100.11a88c9a.svg";